import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import * as Chart from 'chart.js';
import * as jsPDF from 'jspdf';
import { RestService } from '../rest.service';

@Component({
  selector: 'app-graficas',
  templateUrl: './graficas.component.html',
  styleUrls: ['./graficas.component.scss']
})
export class GraficasComponent implements OnInit {

  @ViewChild('content',{static: false}) content: ElementRef;

  selectalert = true;

  chart1;
  chart2;
  chart3;
  chart4;
  chart5;
  chart6;
  chart7;
  chart8;
  chart9;
  chart10;

  // Items => Seleccionar Punto Suministro
  items: Array<any> = [];
  year: number;
  point: any = [];

  item_result: any = [];
  searchTerm: string = '';

  constructor(public rest: RestService) { }

  ngOnInit() {
    this.getPoints();
  }

  private mixedChart(name, dataline1, dataline2, dataline3, databar1, databar2, databar3, nameText) {
    return new Chart(document.getElementById(name), {
      type: 'bar',
      data: {
        labels: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        datasets: [
          {
            label: 'Linea-AA',
            type: 'line',
            borderColor: '#b2bbc3',
            data: dataline1,
            fill: false,
            yAxisID: 'right-y-axis'
          }, {
            label: 'Linea-Actual',
            type: 'line',
            borderColor: '#4cc3ea',
            data: dataline2,
            fill: false,
            yAxisID: 'right-y-axis'
          }, {
            label: 'Linea-Ahorro',
            type: 'line',
            borderColor: '#118a11',
            data: dataline3,
            fill: false,
            yAxisID: 'right-y-axis'
          }, {
            label: 'Barra-AA',
            type: 'bar',
            backgroundColor: '#708090',
            backgroundColorHover: '#35bcec',
            data: databar1,
            yAxisID: 'left-y-axis'
          }, {
            label: 'Barra-Ac',
            type: 'bar',
            backgroundColor: '#add8e6',
            backgroundColorHover: '#4698b3',
            data: databar2,
            yAxisID: 'left-y-axis',
          }, {
            label: 'Barra-Ahorro',
            type: 'bar',
            backgroundColor: '#90ee90',
            backgroundColorHover: '#39a239',
            data: databar3,
            yAxisID: 'left-y-axis'
          }]

      },
      options: {
        title: {
          display: true,
          text: nameText
        },
        scales: {
          yAxes: [{
            id: 'left-y-axis',
            type: 'linear',
            ticks: {
              beginAtZero: true
            },
            position: 'left'
          }, {
            id: 'right-y-axis',
            type: 'linear',
            ticks: {
              beginAtZero: true
            },
            position: 'right'
          }]
        },
        legend: { display: true },
        maintainAspectRatio: false,
        responsive: true
      }
    });
  }

  filterItems(searchTerm) {

    this.item_result = [];
    this.item_result = this.items;

    return this.item_result.filter((item) => {
      return item.cup.toLowerCase().
       indexOf(searchTerm.toLowerCase()) > -1 ||
         item.cif.toLowerCase().
          indexOf(searchTerm.toLowerCase()) > -1;
     });
  }

  setFilteredItems() {
    this.item_result = this.filterItems(this.searchTerm.replace(/ /g, ""));
    this.searchTerm = this.searchTerm.replace(/ /g, "");
  }

  getPoints() {
    this.selectalert = true;
    setTimeout(() => {
      this.selectalert = false;
    }, 1500);
    this.rest.getPuntos(this.year).subscribe((data) => {
      this.items = data['data'];
      this.setFilteredItems();
      this.point = [];
    });
  }
  /*public downloadPDF() {
    let doc = new jsPDF('landscape');
    html2canvas(document.body)
      .then(canvas => {
        var imgData = canvas.toDataURL('image/png', 1.0);
        doc.addImage(imgData, 'JPEG', -50, -15, 350, 220);
        doc.save('Chart.pdf');
      });
  }*/

  refreshData() {
    if (this.chart1) { this.chart1.destroy(); }
    if (this.chart2) { this.chart2.destroy(); }
    if (this.chart3) { this.chart3.destroy(); }
    if (this.chart4) { this.chart4.destroy(); }
    if (this.chart5) { this.chart5.destroy(); }
    if (this.chart6) { this.chart6.destroy(); }
    if (this.chart7) { this.chart7.destroy(); }
    if (this.chart8) { this.chart8.destroy(); }
    if (this.chart9) { this.chart9.destroy(); }
    if (this.chart10) { this.chart10.destroy(); }

    // Chart 1
    const c1l1: any = []; const c1l2: any = []; const c1l3: any = [];
    const c1b1: any = []; const c1b2: any = []; const c1b3: any = [];
    // Chart 2
    const c2l1: any = []; const c2l2: any = []; const c2l3: any = [];
    const c2b1: any = []; const c2b2: any = []; const c2b3: any = [];
    // Chart 3
    const c3l1: any = []; const c3l2: any = []; const c3l3: any = [];
    const c3b1: any = []; const c3b2: any = []; const c3b3: any = [];
    // Chart 4
    const c4l1: any = []; const c4l2: any = []; const c4l3: any = [];
    const c4b1: any = []; const c4b2: any = []; const c4b3: any = [];
    // Chart 5
    const c5l1: any = []; const c5l2: any = []; const c5l3: any = [];
    const c5b1: any = []; const c5b2: any = []; const c5b3: any = [];
    // Chart 6
    const c6l1: any = []; const c6l2: any = []; const c6l3: any = [];
    const c6b1: any = []; const c6b2: any = []; const c6b3: any = [];
    // Chart 7
    const c7l1: any = []; const c7l2: any = []; const c7l3: any = [];
    const c7b1: any = []; const c7b2: any = []; const c7b3: any = [];
    // Chart 8
    const c8l1: any = []; const c8l2: any = []; const c8l3: any = [];
    const c8b1: any = []; const c8b2: any = []; const c8b3: any = [];
    // Chart 9
    const c9l1: any = []; const c9l2: any = []; const c9l3: any = [];
    const c9b1: any = []; const c9b2: any = []; const c9b3: any = [];
    // Chart 10
    const c10l1: any = []; const c10l2: any = []; const c10l3: any = [];
    const c10b1: any = []; const c10b2: any = []; const c10b3: any = [];


    // Chart 1
    if (this.point.graficas[0].data) {
      for (let jindex = 0; jindex < this.point.graficas[0].data.length; jindex++) {
        c1l1.push(this.point.graficas[0].data[jindex]['consumoAcumAA']);
        c1l2.push(this.point.graficas[0].data[jindex]['consumoAcum']);
        c1l3.push(this.point.graficas[0].data[jindex]['ahorroAcum']);
        c1b1.push(this.point.graficas[0].data[jindex]['consumoAA']);
        c1b2.push(this.point.graficas[0].data[jindex]['consumo']);
        c1b3.push(this.point.graficas[0].data[jindex]['ahorro']);
      }
    }

    // Chart 2
    if (this.point.graficas[1].data) {
      for (let jindex1 = 0; jindex1 < this.point.graficas[1].data.length; jindex1++) {
        c2l1.push(this.point.graficas[1].data[jindex1]['consumoAcumAA']);
        c2l2.push(this.point.graficas[1].data[jindex1]['consumoAcum']);
        c2l3.push(this.point.graficas[1].data[jindex1]['ahorroAcum']);
        c2b1.push(this.point.graficas[1].data[jindex1]['consumoAA']);
        c2b2.push(this.point.graficas[1].data[jindex1]['consumo']);
        c2b3.push(this.point.graficas[1].data[jindex1]['ahorro']);
      }
    }

    // Chart 3
    if ( this.point.graficas[2].data) {
      for (let jindex1 = 0; jindex1 < this.point.graficas[2].data.length; jindex1++) {
        c3l1.push(this.point.graficas[2].data[jindex1]['consumoAcumAA']);
        c3l2.push(this.point.graficas[2].data[jindex1]['consumoAcum']);
        c3l3.push(this.point.graficas[2].data[jindex1]['ahorroAcum']);
        c3b1.push(this.point.graficas[2].data[jindex1]['consumoAA']);
        c3b2.push(this.point.graficas[2].data[jindex1]['consumo']);
        c3b3.push(this.point.graficas[2].data[jindex1]['ahorro']);
      }
    }

    // Chart 4
    if( this.point.graficas[3].data) {
      for (let jindex1 = 0; jindex1 < this.point.graficas[3].data.length; jindex1++) {
        c4l1.push(this.point.graficas[3].data[jindex1]['consumoAcumAA']);
        c4l2.push(this.point.graficas[3].data[jindex1]['consumoAcum']);
        c4l3.push(this.point.graficas[3].data[jindex1]['ahorroAcum']);
        c4b1.push(this.point.graficas[3].data[jindex1]['consumoAA']);
        c4b2.push(this.point.graficas[3].data[jindex1]['consumo']);
        c4b3.push(this.point.graficas[3].data[jindex1]['ahorro']);
      }
    }

    // Chart 5
    if( this.point.graficas[4].data) {
      for (let jindex1 = 0; jindex1 < this.point.graficas[4].data.length; jindex1++) {
        c5l1.push(this.point.graficas[4].data[jindex1]['consumoAcumAA']);
        c5l2.push(this.point.graficas[4].data[jindex1]['consumoAcum']);
        c5l3.push(this.point.graficas[4].data[jindex1]['ahorroAcum']);
        c5b1.push(this.point.graficas[4].data[jindex1]['consumoAA']);
        c5b2.push(this.point.graficas[4].data[jindex1]['consumo']);
        c5b3.push(this.point.graficas[4].data[jindex1]['ahorro']);
      }
    }

    // Chart 6
    if( this.point.graficas[5].data) {
      for (let jindex1 = 0; jindex1 < this.point.graficas[5].data.length; jindex1++) {
        c6l1.push(this.point.graficas[5].data[jindex1]['consumoAcumAA']);
        c6l2.push(this.point.graficas[5].data[jindex1]['consumoAcum']);
        c6l3.push(this.point.graficas[5].data[jindex1]['ahorroAcum']);
        c6b1.push(this.point.graficas[5].data[jindex1]['consumoAA']);
        c6b2.push(this.point.graficas[5].data[jindex1]['consumo']);
        c6b3.push(this.point.graficas[5].data[jindex1]['ahorro']);
      }
    }

    // Chart 7
    if( this.point.graficas[6].data) {
      for (let jindex1 = 0; jindex1 < this.point.graficas[6].data.length; jindex1++) {
        c7l1.push(this.point.graficas[6].data[jindex1]['consumoAcumAA']);
        c7l2.push(this.point.graficas[6].data[jindex1]['consumoAcum']);
        c7l3.push(this.point.graficas[6].data[jindex1]['ahorroAcum']);
        c7b1.push(this.point.graficas[6].data[jindex1]['consumoAA']);
        c7b2.push(this.point.graficas[6].data[jindex1]['consumo']);
        c7b3.push(this.point.graficas[6].data[jindex1]['ahorro']);
      }
    }

    // Chart 8
    if( this.point.graficas[7].data) {
      for (let jindex1 = 0; jindex1 < this.point.graficas[7].data.length; jindex1++) {
        c8l1.push(this.point.graficas[7].data[jindex1]['consumoAcumAA']);
        c8l2.push(this.point.graficas[7].data[jindex1]['consumoAcum']);
        c8l3.push(this.point.graficas[7].data[jindex1]['ahorroAcum']);
        c8b1.push(this.point.graficas[7].data[jindex1]['consumoAA']);
        c8b2.push(this.point.graficas[7].data[jindex1]['consumo']);
        c8b3.push(this.point.graficas[7].data[jindex1]['ahorro']);
      }
    }

    // Chart 9
    if( this.point.graficas[8].data) {
      for (let jindex1 = 0; jindex1 < this.point.graficas[8].data.length; jindex1++) {
        c9l1.push(this.point.graficas[8].data[jindex1]['consumoAcumAA']);
        c9l2.push(this.point.graficas[8].data[jindex1]['consumoAcum']);
        c9l3.push(this.point.graficas[8].data[jindex1]['ahorroAcum']);
        c9b1.push(this.point.graficas[8].data[jindex1]['consumoAA']);
        c9b2.push(this.point.graficas[8].data[jindex1]['consumo']);
        c9b3.push(this.point.graficas[8].data[jindex1]['ahorro']);
      }
    }

    // Chart 10
    if( this.point.graficas[9].data) {
      for (let jindex1 = 0; jindex1 < this.point.graficas[9].data.length; jindex1++) {
        c10l1.push(this.point.graficas[9].data[jindex1]['consumoAcumAA']);
        c10l2.push(this.point.graficas[9].data[jindex1]['consumoAcum']);
        c10l3.push(this.point.graficas[9].data[jindex1]['ahorroAcum']);
        c10b1.push(this.point.graficas[9].data[jindex1]['consumoAA']);
        c10b2.push(this.point.graficas[9].data[jindex1]['consumo']);
        c10b3.push(this.point.graficas[9].data[jindex1]['ahorro']);
      }
    }

    this.chart1 = this.mixedChart('mix1', c1l1, c1l2, c1l3, c1b1, c1b2, c1b3, 'Evolucion termino factura total');
    this.chart2 = this.mixedChart('mix2', c2l1, c2l2, c2l3, c2b1, c2b2, c2b3, 'Evolucion termino potencia facturada ');
    this.chart3 = this.mixedChart('mix3', c3l1, c3l2, c3l3, c3b1, c3b2, c3b3, 'Evolucion termino energia activa');
    this.chart4 = this.mixedChart('mix4', c4l1, c4l2, c4l3, c4b1, c4b2, c4b3, 'Evolucion termino energia reactiva');
    this.chart5 = this.mixedChart('mix5', c5l1, c5l2, c5l3, c5b1, c5b2, c5b3, 'Evolucion precio potencia');
    this.chart6 = this.mixedChart('mix6', c6l1, c6l2, c6l3, c6b1, c6b2, c6b3, 'Evolucion precio energia activa');
    this.chart7 = this.mixedChart('mix7', c7l1, c7l2, c7l3, c7b1, c7b2, c7b3, 'Dinero ahorrado diario acumulado');
    this.chart8 = this.mixedChart('mix8', c8l1, c8l2, c8l3, c8b1, c8b2, c8b3, 'Evolucion potencia facturada [kW]');
    this.chart9 = this.mixedChart('mix9', c9l1, c9l2, c9l3, c9b1, c9b2, c9b3, 'Evolución energia activa consumida [kWh]');
    this.chart10 = this.mixedChart('mix10', c10l1, c10l2, c10l3, c10b1, c10b2, c10b3, 'Evolucion energia reactiva facturada [kVArh]');
  }

}
